module.exports = __webpack_public_path__ + "img/Rectangle 19header.7ee01a66.png";